module.exports = __webpack_public_path__ + "static/media/filetype-csv.5cad6f00.svg";